import React from 'react';

import LegalPage from 'components/LegalPage';
import content from './content.json';

export default function PrivacyPolicy() {
  return (
    <LegalPage
      content={content}
      seoTitle="Privacy Policy · Lyfe"
      seoDescription="How Lyfe Social collects, uses, shares and protects your personal information."
      path="/privacy-policy"
      fallbackTitle="Privacy Policy"
    />
  );
}
